import styled from 'styled-components'

export const Card = styled.div`
  text-align: center;
  margin-top: 3rem;
  background-color: white;

  border: 1px solid ${({theme}) => theme.palette.grayscale[5]};
  border-radius: 0.5rem;
  padding: 2rem;
  height: 23rem;

  -webkit-box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.25);
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.25);
`

export const Image = styled.img`
  height: 6rem;
`;

export const Action = styled.div`
  font-size: 1.3rem;
  color: ${({theme}) => theme.palette.grayscale[2]};
  margin-top: 2rem;
  font-weight: 600;
`;


export const Description = styled.div`
  font-size: 0.8rem;
  margin-top: 1rem;
  color: ${({theme}) => theme.palette.grayscale[2]};
  font-weight: 100;
`;
